<template>
  <div class="water-mark"></div>
</template>
<script>
import website from "@/config/website";
export default {
  name: 'WaterMark',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null
    }
  },
  mounted() {
      this.createWaterMark()
      let loopInterval=website.waterMarkInterval?website.waterMarkInterval:5000
      this.timer = setInterval(this.createWaterMark, loopInterval) //定时更新水印内容
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    //获取登录的用户名
    getUserName() {
      const { userInfo } = this.$store.state.user
      //console.log(userInfo)
      return userInfo && userInfo.user_name ? userInfo.user_name+'【'+userInfo.nick_name+'】' : '未登录用户'
    },
    //获取当前打开的菜单名称
    getPageTitle() {
      const route = this.$route
      return route && route.name ? route.name : ''
    },
    createWaterMark() {
      const canvas = document.createElement('canvas')
      canvas.width = 400
      canvas.height = 160
      const ctx = canvas.getContext('2d')
      
      ctx.fillStyle = 'rgba(200,200,200, 0.2)'
      ctx.font = '18px Microsoft YaHei'
      ctx.rotate(-15 * Math.PI / 180)
      
      const currentTime = new Date().toLocaleString()
      
      ctx.fillText('Matrix 智慧管控平台', 0, 100)
      ctx.fillText(this.getUserName() + '  ' + this.getPageTitle(), 0, 120)
      ctx.fillText(currentTime, 0, 140)
      
      const base64Url = canvas.toDataURL()
      const waterMarkDiv = document.querySelector('.water-mark')
      if (waterMarkDiv) {
        waterMarkDiv.style.backgroundImage = 'url(' + base64Url + ')'
      }
    }
  }
}
</script>

<style scoped>
.water-mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  background-repeat: repeat;
  z-index: 9999;
}
</style> 